// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2pn4y","inner":"Form_inner__2XHKm","range":"Form_range__sZZ5Z","name":"Form_name__3BFyG","actions":"Form_actions__2tw0K"};